import { generatePath } from 'quartz-routing/react-router';
import { SHORT_CONTENT_URL_FRAGMENT } from '../../constants/Navigation';
import { OVERVIEW_MODAL_PLAYLIST_PARAM } from 'academy-common-lib/features/overview/overviewConsts';
import { getOverviewModalParams } from 'academy-common-lib/utils/url';
import { PLAYLIST_SEARCH_PARAM } from '../playlistContent/playlistContentConsts';
export const getShortContentUrl = ({
  shortId,
  playlistId,
  search: locationSearch
}) => {
  const searchParams = new URLSearchParams(locationSearch);
  if (playlistId) searchParams.set(PLAYLIST_SEARCH_PARAM, playlistId.toString());
  const pathname = generatePath(SHORT_CONTENT_URL_FRAGMENT, {
    shortId
  });
  const search = searchParams.toString();
  return {
    search,
    pathname,
    hash: '',
    state: undefined,
    fullUrl: `${pathname}${search ? `?${search}` : ''}`
  };
};
export const getShortContentOverviewUrl = ({
  shortId,
  playlistId,
  overviewType,
  pathname: locationPathname = '',
  search: locationSearch
}) => {
  const searchParams = new URLSearchParams(locationSearch);
  if (playlistId) searchParams.append(OVERVIEW_MODAL_PLAYLIST_PARAM, playlistId.toString());
  const modalParams = getOverviewModalParams({
    id: shortId,
    type: 'SHORT_FORM_CONTENT',
    source: overviewType
  });
  Object.entries(modalParams).forEach(([key, value]) => {
    searchParams.set(key, value);
  });
  const search = searchParams.toString();
  return {
    search,
    pathname: locationPathname,
    hash: '',
    state: undefined,
    fullUrl: `${locationPathname}${search ? `?${search}` : ''}`
  };
};